import { render, staticRenderFns } from "./cmpNavItem.vue?vue&type=template&id=197ac512&"
import script from "./cmpNavItem.vue?vue&type=script&lang=js&"
export * from "./cmpNavItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports